import React from 'react'
import { useRouter } from 'next/router'
import { BigSale } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useAppDispatch } from 'src/app/hooks'
import { Button, Popconfirm, Upload } from 'antd'
import { deleteSaleDocument, sendSaleDocument } from 'src/features'
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons'

interface SaleDocumentFormProps {
  sale: BigSale,
  keyField: string,
  keyFile: string,
  buttonLabel: string
}

const SaleDocumentForm: React.FC<SaleDocumentFormProps> = (props) => {
  const { t } = useTranslation()
  const { sale, keyFile, buttonLabel, keyField } = props
  const dispatch = useAppDispatch()
  const { id } = useRouter().query

  const getFileList = (file: any) => file ? [file] : []

  const handleFileChange = ({ file }) => {
    dispatch(sendSaleDocument(Number(id), file, keyField))
  }

  const handleDelete = () => {
    dispatch(deleteSaleDocument(Number(id), keyField))
  }

  return <>
    <Upload
      beforeUpload={() => false}
      accept='application/pdf'
      fileList={getFileList(sale[keyFile])}
      onChange={handleFileChange}
      showUploadList={{
        showDownloadIcon: true,
        showRemoveIcon: false
      }}
    >
      <Button icon={<UploadOutlined />}>{buttonLabel}</Button>
    </Upload>
    {sale[keyFile] && (
      <Popconfirm
        title={t('general.SureDelete')}
        onConfirm={handleDelete}
        okText={t('general.Yes')}
        cancelText={t('general.Cancel')}
      >
        <Button
          danger
          type='text'
          className='radius-100'
          icon={<DeleteOutlined />}
        />
      </Popconfirm>
    )}
  </>
}

export default SaleDocumentForm
